import { useState, useRef, useEffect } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { BouncingBox } from "../BouncingBox.jsx/BouncingBox";
import bruhSound from "../../assets/sounds/bruh.mp3";

export default function GarrettButton() {
  const [boxes, setBoxes] = useState([]);
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");
  const bruhAudio = useRef(null);

  useEffect(() => {
    bruhAudio.current = new Audio(bruhSound);
  }, []);

  const handleTextClick = () => {
    if (bruhAudio.current) {
      bruhAudio.current.currentTime = 0;
      bruhAudio.current.play();
    }

    const newBox = { id: Date.now() };
    console.log("Text clicked, adding box:", newBox);
    setBoxes((prev) => [...prev, newBox]);
  };

  return (
    <Box>
      <Text
        color={textColor}
        fontFamily="Lilita One"
        fontSize="xl"
        cursor="pointer"
        onClick={handleTextClick}
      >
        Garrett
      </Text>

      {boxes.map((box) => (
        <BouncingBox key={box.id} id={box.id} image="Otter" />
      ))}
    </Box>
  );
}
